import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown, FiSearch, FiCheck } from 'react-icons/fi';
import { useCurrency } from '../../app/CurrencyContext';
import styles from './CurrencySelector.module.css';

const CurrencySelector: React.FC = () => {
  const { currencies, selected, setSelected, loading } = useCurrency();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const filtered = currencies.filter((c) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return c.code.toLowerCase().includes(q) || c.name.toLowerCase().includes(q);
  });

  return (
    <div className={styles.wrap} ref={ref}>
      <button type="button" className={styles.trigger} onClick={() => setOpen((v) => !v)} disabled={loading}>
        <span>{selected}</span>
        <FiChevronDown className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`} />
      </button>

      {open && (
        <div className={styles.panel}>
          <div className={styles.searchWrap}>
            <FiSearch className={styles.searchIcon} />
            <input
              autoFocus
              className={styles.searchInput}
              placeholder="Search currency…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className={`${styles.list} thinScroll`}>
            {filtered.length === 0 && <div className={styles.empty}>No currency found.</div>}
            {filtered.map((c) => (
              <button
                key={c.code}
                type="button"
                className={`${styles.item} ${c.code === selected ? styles.itemActive : ''}`}
                onClick={() => { setSelected(c.code); setOpen(false); setSearch(''); }}
              >
                <span className={styles.itemSymbol}>{c.symbol}</span>
                <span className={styles.itemCode}>{c.code}</span>
                <span className={styles.itemName}>{c.name}</span>
                {c.code === selected && <FiCheck className={styles.itemCheck} />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
